import { useMemo, type ReactNode } from 'react';

import type { NotificationType } from 'app/src/components/NotificationsMenu';
import { ReactionAnalyticsContext } from './ReactionAnalyticsContext';

interface InputContainerIds {
  idBoard?: string | null | undefined;
  idCard?: string | null | undefined;
  idList?: string | null | undefined;
}
interface ReactionAnalyticsContextProviderProps {
  analyticsContainers: InputContainerIds;
  idAction?: string;
  idNotification?: string;
  notificationType?: NotificationType;
  children: ReactNode;
}

export const ReactionAnalyticsContextProvider = ({
  analyticsContainers,
  idAction,
  idNotification,
  notificationType,
  children,
}: ReactionAnalyticsContextProviderProps) => {
  const analyticsContext = useMemo(
    () => ({
      actionId: idAction || '',
      boardId: analyticsContainers.idBoard || '',
      cardId: analyticsContainers.idCard || '',
      listId: analyticsContainers.idList || '',
      notificationId: idNotification || '',
      notificationType: notificationType || '',
    }),
    [analyticsContainers, idAction, idNotification, notificationType],
  );

  return (
    <ReactionAnalyticsContext.Provider value={analyticsContext}>
      {children}
    </ReactionAnalyticsContext.Provider>
  );
};
